import { Injectable } from '@angular/core';
import { Observable,of } from 'rxjs';
import { userProfileList } from '../../../../../mockData/development/user-profile';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor() { }

  data = userProfileList;

  /**
  *getUsers() - method to get the signed in user information
  */

  getUsers(): Observable<any> {
    return of(this.data)
  }

}
